import { DecimalPipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Component, effect, inject, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { Customer } from '../../interface/customer';
import { CustomerInfoService } from '../../service/customer.service';

registerLocaleData(localeIt);

@Component({
  selector: 'app-wallet',
  imports: [
    MatCardModule,
    MatTooltipModule,
    RouterLink,
    TranslateModule,
    DecimalPipe
  ],
  templateUrl: './wallet.html',
  styles: ``,
})
export class Wallet {
  public customer = signal<Customer | undefined>(undefined);
  public json: JSON = JSON;

  private customerService = inject(CustomerInfoService);

  constructor() {
    effect(() => {
      if (this.customerService.customerId) { this.loadCustomer(); }
    });
  }

  private loadCustomer(): void {
    firstValueFrom(this.customerService.getCustomer())
      .then((customer) => { this.customer.set(customer); });
  }
}
